import { useMutation } from "@tanstack/react-query";

import * as API from "@krea/customer-features/store/banking-data/api";

interface IFinalizeProps {
  resourceId: string;
  resourceType: string;
}

interface IFinalizeMutationParams {
  requisitionId: string;
}

export const useFinalize = ({ resourceId, resourceType }: IFinalizeProps) => {
  return useMutation<undefined, undefined, IFinalizeMutationParams>({
    mutationFn: async ({ requisitionId }) => {
      await API.finalize(resourceId, resourceType, requisitionId);
    },
  });
};
